const page = {
  jpLogin: 'jpLogin'
};

export default {
  event: {
    'j-uid-token-login-btn': [
      {
        type: 'click',
        event: 'click-uid-token-login-btn'
      }
    ],
    'j-uid-token-ask': [
      {
        type: 'click',
        event: 'click-uid-token-login-ask'
      }
    ]
  },
  enter: {
    jpLogin: { event: page.jpLogin }
  },
  router: {
    jpLogin: { event: page.jpLogin }
  }
};
